import { useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";
import WebService from "../../Services/WebService";
import WebUrl from "../../Services/WebUrl";

function AddProduct() {
   
  // const[msg,setMsg] = useState('Product Not Add')
  const[msg,setMsg] = useState()
  const[productlist,setProductList] = useState([])
  const[catList,setCatList] = useState([])
  const[brandList,setBrandList] = useState([])

  var product_name = useRef()
  var product_price = useRef()
  var product_cat = useRef()
  var product_brand = useRef()
  var product_image = useRef()


  useEffect(()=>{
    loadCategoryData()
    loadBrandData()
    loadProductList()
 },[])

 var loadProductList =async ()=>{
   var product_list = await WebService.getAPI(WebUrl.load_product)
   console.log(product_list)
   setProductList(product_list.data.data)

 }

  var loadCategoryData = async ()=>{
   // alert("acjhasdvcjhkdc 1");
    var res = await WebService.getAPI(WebUrl.load_category);
   // alert("acjhasdvcjhkdsjkduwdjkfsdac 2");
    console.log("Result is : "+res)
    setCatList(res.data)
    //alert("acjhasdvcjhkdaasklasdxjkdlkaxjklasnxdjklasxc 3");
    console.log("Cate List : "+res.data)
  }
  var loadBrandData = async ()=>{
    var result =  WebService.getAPI(WebUrl.load_brand);
    console.log(result)
    setBrandList(result.data.data)
  }

  var addProductDetails = ()=>{
    
  }

  return<main id="main" className="main">
   <section className="section">
    <div className="row">
      <div className="col-lg-12">

        <div className="card">
          <div className="card-body">
           

            {/* General Form Elements */}
          {/* End General Form Elements */}
            <h1>{msg}</h1>
          </div>
        </div>
       
        <h1 style={{textAlign:'center'}}>USER LIST : </h1>
        <br/><br/>
        <div className="table-responsive">
            <table className="table table-bordered table-hover table-striped"  style={{ border: '4px solid black' }}>
              <tr>
                 <th>S.No</th>
                 <th>Id</th>
                 <th>Name</th>
                 <th>Email</th>
                 <th>Mobile</th>
                 <th>Address</th>
                 <th>City</th>
                 <th>State</th>
                 <th>Operation</th> 
              </tr>
              <tbody>
              {productlist.map((res,index)=>{
                return<tr>
                  <td>{index+1}</td>
                  <td>{res.id}</td>
                  <td>{res.name}</td>
                  <td>{res.email}</td>
                  <td>{res.mobile}</td>
                  <td>{res.address}</td>
                  <td>{res.city}</td>
                  <td>{res.state}</td>
                  <button style={{ backgroundColor: '#dc3545', color: '#fff', border: 'none', padding: '5px 10px', cursor: 'pointer' }}>Delete</button>
                </tr>
              })}
              </tbody>
            </table>
            </div>

      </div>

      
    </div>
  </section>

</main>
}

export default AddProduct;
